import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Container } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";

const generalUsageData = [
  {
    question: "Can I use SeoBix for multiple websites?",
    answer:
      "Yes, SeoBix is designed to be flexible and can be used for multiple websites, depending on the subscription plan you choose.",
  },
  {
    question: "Is SeoBix free, or does it require a subscription?",
    answer:
      "SeoBix offers a free trial for new users. After the trial, you can choose from various subscription plans based on your requirements.",
  },
  {
    question: "How does SeoBix compare to other SEO tools in the market?",
    answer:
      "SeoBix stands out by dynamically updating SEO settings through a  offering advanced features like site speed optimization, UTM creation, and schema markup, all tailored for small businesses.",
  },
  {
    question: "Can I test SeoBix before purchasing a subscription?",
    answer:
      "Yes, a free trial is available to help you explore SeoBix's features before committing to a subscription plan.",
  },
];
const customizationData = [
  {
    question: "Can I customize SeoBix to suit my business requirements?",
    answer:
      "Absolutely! SeoBix allows you to modify SEO settings, meta tags, and content to match your specific business needs and goals.",
  },
  {
    question: "Does SeoBix work with all website themes and designs?",
    answer:
      "Yes, SeoBix is compatible with most website themes and custom designs, making it suitable for diverse platforms.",
  },
  {
    question:
      "Is SeoBix compatible with other tools or platforms I use for my website?",
    answer:
      "SeoBix integrates seamlessly with popular website builders and third-party tools, ensuring smooth operation with your existing setup.",
  },
];
const technicalData = [
  {
    question:
      "Will using SeoBix affect my website’s performance or loading speed?",
    answer:
      "No, SeoBix is optimized for performance and operates in the background without impacting your site’s loading speed.",
  },
  {
    question:
      "Can SeoBix be integrated with websites hosted on WordPress.com or other platforms?",
    answer:
      "Yes, SeoBix works with WordPress.com and other hosting platforms, including custom-built websites.",
  },
  {
    question: "Do I need to remove existing SEO solutions before using SeoBix?",
    answer:
      "While it's not mandatory, we recommend removing other SEO tools to prevent conflicts and ensure optimal performance with SeoBix.",
  },
  {
    question: "Is it possible to run SeoBix alongside another SEO tool?",
    answer:
      "Yes, but it's best to rely on SeoBix solely to avoid overlapping configurations that might affect your site’s SEO.",
  },
];
const seoTransitionData = [
  {
    question:
      "If I switch to SeoBix, will my current search engine rankings be impacted?",
    answer:
      "No, SeoBix is designed to maintain or improve your rankings during the transition by importing and enhancing your current SEO settings.",
  },
  {
    question:
      "Does SeoBix provide assistance with the initial setup and configuration?",
    answer:
      "Yes, SeoBix offers detailed guides, video tutorials, and customer support to help you with setup and integration.",
  },
];
const updatesSupportData = [
  {
    question: "How frequently is SeoBix updated with new features?",
    answer:
      "SeoBix regularly rolls out updates to include new features and keep up with the latest SEO trends.",
  },
  {
    question: "How do I update SeoBix when new versions are released?",
    answer:
      "Updates are automatic for cloud-based users, or you can manually install updates via your account dashboard.",
  },
  {
    question: "Is customer support available for users of SeoBix?",
    answer:
      "Yes, SeoBix provides 24/7 customer support via email, chat, and support tickets.",
  },
  {
    question: "How quickly can I expect a response from the support team?",
    answer:
      "Most queries are addressed within 24 hours, with priority support available for premium users.",
  },
];
const generalInfoData = [
  {
    question: "What is SeoBix?",
    answer:
      "SeoBix is a dynamic SEO tool that enables website owners and small businesses to optimize their site's content, meta tags, and other SEO elements directly.",
  },
  {
    question: "Who can benefit from SeoBix?",
    answer:
      "SeoBix is designed for small businesses, web developers, and digital marketers looking for a simple, effective, affordable solution to improve their website’s search engine ranking.",
  },
  {
    question: "How does SeoBix work?",
    answer:
      "SeoBix dynamically updates your website’s SEO settings, including meta descriptions, keywords, and tags.",
  },
];
const featuresData = [
  {
    question: "What features does SeoBix provide?",
    answer:
      "SeoBix offers:\nSite speed optimization\nCrawlability and indexability fixes\nDuplicate content management\nCampaign management tools\nSite health audits\nUTM and short link creation\nSchema markup implementation\nDynamic content updates for meta tags and SEO elements",
  },
  {
    question: "Can SeoBix help with creating UTM links?",
    answer:
      "Yes, SeoBix allows you to create, manage, and track UTM links to monitor your campaign performance effectively.",
  },
  {
    question: "Does SeoBix provide analytics?",
    answer:
      "While SeoBix focuses on technical SEO, it integrates seamlessly with analytics tools to track the performance of your SEO campaigns.",
  },
  {
    question: "Does SeoBix support multilingual websites?",
    answer:
      "Yes, SeoBix supports multilingual websites and allows you to manage SEO elements for multiple languages effectively.",
  },
];
const supportAssistanceData = [
  {
    question: "Does SeoBix offer customer support?",
    answer:
      "Yes, SeoBix provides 24/7 customer support via email and live chat to help with integration, troubleshooting, and optimization tips.",
  },
  {
    question: "Is there any documentation or training available?",
    answer:
      "Absolutely! SeoBix offers detailed guides, tutorials, and video walkthroughs to help you make the most of the tool.",
  },
  {
    question: "Can SeoBix help me fix SEO issues on my site?",
    answer:
      "Yes, SeoBix's site health audits and crawlability fixes are designed to identify and resolve SEO issues on your website.",
  },
];
const technicalDetailsData = [
  {
    question: "Does SeoBix slow down my website?",
    answer:
      "No, SeoBix is optimized for performance and works in the background without affecting your site speed.",
  },
  {
    question: "Can SeoBix manage large-scale websites?",
    answer:
      "Yes, SeoBix is scalable and can handle websites of all sizes, from small business sites to larger enterprise-level platforms.",
  },
];

const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const allFaqData = [
      ...generalUsageData,
      ...customizationData,
      ...technicalData,
      ...seoTransitionData,
      ...updatesSupportData,
      ...generalInfoData,
      ...featuresData,
      ...supportAssistanceData,
      ...technicalDetailsData,
    ];
  
    const uniqueFaqData = [];
    const seenQuestions = new Set();
  
    for (const faq of allFaqData) {
      const normalizedQuestion = faq.question.trim().toLowerCase();
      if (!seenQuestions.has(normalizedQuestion)) {
        seenQuestions.add(normalizedQuestion);
        uniqueFaqData.push(faq);
      }
    }
  
    const faqStructuredData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": uniqueFaqData.map((faq) => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer.replace(/\n/g, "<br/>"),
        },
      })),
    };
  
    const existingScript = document.querySelector('script[data-faq-schema="true"]');
    if (existingScript) existingScript.remove();
  
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.faqSchema = "true";
    // script.innerHTML = JSON.stringify(faqStructuredData);
    document.head.appendChild(script);
  
    return () => {
      const scriptTag = document.querySelector('script[data-faq-schema="true"]');
      if (scriptTag) document.head.removeChild(scriptTag);
    };
  }, []);
  
  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        <Nav />
      </div>

      <div className="container p-0">
        <div className=" mt-3">
          <div className="row mx-md-0 mx-3 mt-sm-3">
            <div className="col-md-1"></div>
            <div className="col m-0 p-0">
              <div className="container m-0 p-0">
                <h4 className="text-center">FAQ</h4>

                <Accordion className="mt-2">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>General Usage</Accordion.Header>
                    <Accordion.Body>
                      {generalUsageData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Accordion className="mt-2">
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      Customization and Compatibility
                    </Accordion.Header>
                    <Accordion.Body>
                      {customizationData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Accordion className="mt-2">
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      Performance and Technical Questions
                    </Accordion.Header>
                    <Accordion.Body>
                      {technicalData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Accordion className="mt-2">
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>
                      SEO Transition and Setup
                    </Accordion.Header>
                    <Accordion.Body>
                      {seoTransitionData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <Accordion className="mt-2">
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>Updates and Support</Accordion.Header>
                    <Accordion.Body>
                      {updatesSupportData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <Accordion className="mt-2">
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>General Info</Accordion.Header>
                    <Accordion.Body>
                      {generalInfoData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <Accordion className="mt-2">
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>Features</Accordion.Header>
                    <Accordion.Body>
                      {featuresData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <Accordion className="mt-2">
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>Support and Assistance</Accordion.Header>
                    <Accordion.Body>
                      {supportAssistanceData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <Accordion className="mt-2 mb-3">
                  <Accordion.Item eventKey="8">
                    <Accordion.Header>Technical Details</Accordion.Header>
                    <Accordion.Body>
                      {technicalDetailsData.map((item, index) => (
                        <div key={index} className="mb-3">
                          <h6 className="fw-bold">{item.question}</h6>
                          <p>{item.answer}</p>
                        </div>
                      ))}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
            <div className="col-md-1"></div>
          </div>
        </div>
      </div>
      {/* end */}
      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
      
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default FAQ;
